import { ThemeOptions } from '@mui/material';

export const breakpoints: ThemeOptions['breakpoints'] = {
  values: {
    xl: 1536,
    lg: 1200,
    md: 900,
    sm: 600,
    xs: 0
  }
};
